import React, {
    useState,
    useEffect,
    useCallback,
    useRef
} from 'react'
import PropTypes from 'prop-types'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import classNames from 'classnames'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import NumberFormat from 'react-number-format';
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// import { useHistory } from "react-router-dom";

// hooks
import useWindowSize from '../../../../Hooks/useWindowSize'
// import useRouter from 'Hooks/useRouter'
// import useLockBodyScroll from 'Hooks/useLockBodyScroll'
// import useScrollTop from 'Hooks/useScrollTop'

// Atoms
import Button, { ButtonCategory } from './../../../Atoms/Button'
// import Dropdown from './../../../Atoms/Dropdown'
import SearchField from './../../../Atoms/SearchField'
import Title, { TitleTag, TitleStyle } from './../../../Atoms/Title';
import InputSelect, { InputSelectType } from './../../../Atoms/InputSelect';

// Mol
// import PlayPlanCardMol from './../../../Molecules/Cards/Plan/Play'
import General2PlanCardMol from './../../../Molecules/Cards/Plan/General2'
// import BreadcrumbMol from 'Components/Molecules/Breadcrumb'
import RangeSlider from './../../../Molecules/RangeSlider'
import PaginationMol from './../../../Molecules/Pagination'

import Modal, {ModalSize} from '../../../Molecules/Modal'
import MLocationPartModal from '../../../Molecules/Modal/Part/MLocation'
import MTooltipModal from '../../../Molecules/Modal/Part/MTooltip'

// Sass
import '../../../../Sass/includes/Components/modules/C23.sass'

import C25PeopleOrg from '../C25v2'
// import $ from "jquery"

const queryParams = new URLSearchParams(window.location.search);
const plataformasStreamingId = 5
const serviciosId = 1

const ServiceFilter = React.memo((props) => {
    const {
        onSubmit,
        showFilter,
        setShowFilter,
        // optionsOrder,
        // dataRegiones,
        //optionsRegiones,
        optionsCiudades,
        dataFilterTypes,
        dataFilterTypesHead,
        //rangePrice,
        handleChangeFilterPrice,
        getPlanesByCheckBox,
        getPlanesByCheckBoxHead,
        // keysTypeCompare,
        counterFilters,
        clearFilters,
        ciudad,
        setCiudad,
        setCiudadText,
        estrato,
        setEstrato,
        setEstratoText,
        familia,
        filterMulti,
    } = props
    
    //const [rangeMb] = useState(props.rangeMb)

    const [prepagoId] = useState(38)//fi_filtro prepago
    const [hPrepago] = useState([10])
    const [postpagoId] = useState(39)//fi_filtro postpago
    const [hPostPago] = useState([3,11,12])



    // const router = useRouter()
    const {
        width: widthWindow,
    } = useWindowSize()

    const [rangePrice] = useState(props.rangePrice)
    //console.log("mbasignar", props.rangeMb, props.rangeMb)
    //const [rangeMb] = useState({min:props.rangeMb.min, max:props.rangeMb.max})
    
    const schemaFilter = yup.object().shape({
        // rangeMin: 
        //     yup.number()
        //         .typeError('El rango minimo solo puede contener números')
        //         .min(10, 'El rango minimo debe ser igual o mayor que 10'),
        // rangeMax: 
        //     yup.number()
        //         .typeError('El rango maximo solo puede contener números')
        //         // .matches(/[0-9]+/gi, "Enter number only")
        //         // .length(3, 'Mas de 3'),
    });

    // const {
    //     paymentType: paymentTypeQuery , 
    //     paymentMethod : paymentMethodQuery,
    //     option: optionQuery,
    // } = router.query

    // //console.log('query: ', router.query)

    const {
        register,
        handleSubmit,
        // watch, 
        // errors, 
        // getValues,  
        // control,
        setValue,
        //formState, 
        unregister
    } = useForm({
        defaultValues: {
            minMb: '',
            maxMb: '',
            // typePlan: [],
            region: null,
            zone: null,
        },
        resolver: yupResolver(schemaFilter),
    });
    // 
    // const WatchAllFields = watch()
    // console.log(WatchAllFields)
    // useEffect(()=>{
    //     console.log('Valores cambiando de los filtros', WatchAllFields);
    // },[WatchAllFields]) 

    useEffect(() => {
        register("minMb"); // custom register minPrice input
        register("maxMb"); // custom register maxprice input
        register("minPrice"); // custom register minPrice input
        register("maxPrice"); // custom register maxprice input
        return () => {
            unregister("minMb"); // custom register minPrice input
            unregister("maxMb");
            unregister("minPrice"); // custom register minPrice input
            unregister("maxPrice");
        }
    }, [register, unregister])

    const handleChangePrice = useCallback((valores) => {
        setValue('minPrice', valores.minPrice)
        setValue('maxPrice', valores.maxPrice)
        handleChangeFilterPrice(valores)
    }, [setValue, handleChangeFilterPrice])

    /*const handleChangeMb = useCallback((valores) => {
        setValue('minMb', valores.minMb)
        setValue('maxMb', valores.maxMb)
        //handleChangeFilterMb(valores)
    }, [setValue])*/

    const classMain = classNames(
        'c23FilterMain',
        { 'c23FilterMainHide': !showFilter },
    )

    useEffect(() => {
        if (widthWindow > 960) {
            setShowFilter(true)

        } else if (widthWindow <= 960) {
            setShowFilter(false)
        }
    }, [widthWindow, setShowFilter])

    const C23Filtercollapse = (props) =>{

        const {
            init= true,
            display='block'
        } = props
    
        const [cond, setCond] = useState(init )
    
        return (
            <div key={uuid()} style={{display: display}} className={`c23FilterBlock  c23FilterBlockCollapse ${cond ? 'c23FilterBlockHidden':''}`}>
                {props.render(cond, setCond)}
            </div>
        )
    }
    
    const InputCheckHijosSHO = (itemHi) => {
        
        return (
            <>  
            
                {
                    itemHi.value?.map((subitemHi, subIndex) => (
                        <>
                            {
                                subitemHi.lstHijos?.length ?
                                <C23Filtercollapse key={uuid()} display={subitemHi.checked ?'block':'none'}  init={false} render={(cond , setCond)=>(
                                    <>
                                        <div  className='c23FilterSubtitle' onClick={()=>setCond(c=>!c)}>
                                            <p>
                                                {subitemHi.Descripcion}
                                            </p>
                                            <i className={`${cond ? 'ico-chevron-down': 'ico-chevron-up'}`}></i>
                                        </div>
                                        <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                                            <SimpleBar style={{ maxHeight: "200px" }}>
                                                {
                                                    subitemHi.lstHijos.map((subitem, subIndex) => (
                                                        <InputSelect
                                                            key={uuid()}
                                                            type={InputSelectType.CHECKBOX}
                                                            text={subitem.fc_DESCRIPCION}
                                                            name={subitem.fi_OPCION_FILTRO}
                                                            className='c23FilterCheckbox'
                                                            onChange={e => { getPlanesByCheckBox(e, subitem) }}
                                                            checked={subitem.checked}
                                                        />
                                                    ))
                                                }
                                            </SimpleBar>
                                        </div>
                                    </>
                                )}/>
                                : null
                            }
                        </>
                    ))
                }

            </>
        )
    }
    console.log("dataFilterTypes-------------- before filter", dataFilterTypes)
    const InputCheckSelectData = dataFilterTypes.filter(f => {
        if(familia === 'SHO'){
            let element = dataFilterTypes.find(fi => fi.idFil === serviciosId).value
            let eleFil = element.filter(fi => fi.checked)
            if(f.idFil === plataformasStreamingId && eleFil.length < 3){
                return false
            }
            return true
        } else {
            let elChecked = dataFilterTypesHead.find(fil => fil.checked)?.id
            if(elChecked && elChecked === prepagoId){//id filtro prepago
                return f.value.find(t => hPrepago.includes(t.fi_FILTRO))//id filtro paquetes
            } else if(elChecked && elChecked === postpagoId){//id filtro postpago
                return f.value.find(t => hPostPago.includes(t.fi_FILTRO))//id filtro tipo necesidad o plataformas
            }
            return false
        }
    }).map((item, index) => (        
        <>
        <C23Filtercollapse key={uuid()} init={false} render={(cond , setCond)=>(
            <>
                <div className='c23FilterSubtitle' onClick={()=>setCond(c=>!c)}>
                    <p>
                        {item.name}
                    </p>
                    <i className={`${cond ? 'ico-chevron-down': 'ico-chevron-up'}`}></i>
                </div>
                <div className={`c23FilterBlockItems c23FilterBlockItemsShow c23FilterBlockBottom`} >
                    <SimpleBar style={{ maxHeight: "200px" }}>
                        {
                            item.value && item.value.map((subitem, subIndex) => (
                                <>
                                    <InputSelect
                                        key={uuid()}
                                        type={item.name === "Planes" ? InputSelectType.RADIO : InputSelectType.CHECKBOX}
                                        text={subitem.Descripcion}
                                        name={item.name === "Planes" ? "Planes" : subitem.id}
                                        value={subitem.id}
                                        className='c23FilterCheckbox'
                                        onChange={e => { getPlanesByCheckBox(e, subitem) }}
                                        checked={subitem.checked}
                                    />
                                    {
                                        familia === 'SMO' && subitem.lstHijos && subitem.checked ?
                                        subitem.lstHijos.map((subitem2, subIndex) => (
                                            <InputSelect
                                                key={uuid()}
                                                type={InputSelectType.CHECKBOX}
                                                text={subitem2.fc_DESCRIPCION}
                                                name={subitem2.fi_FILTRO}
                                                className='c23FilterCheckbox c23FilterCheckboxLvl2'
                                                onChange={e => { getPlanesByCheckBox(e, subitem2) }}
                                                checked={subitem2.checked}
                                            />
                                        )) : null
                                    }
                                </>
                                
                            ))
                        }
                    </SimpleBar>
                </div>
            </>    
        )}/>
            { familia !== 'SMO' ?
            InputCheckHijosSHO(item) : null 
            }
        </>
        
        
    ))

    const InputCheckSelectDataHead = dataFilterTypesHead.map((item, index) => (
        <InputSelect
            key={uuid()}
            type={InputSelectType.RADIO}
            // register={register("typePlay[0]", {required: false})} 
            text={item.Descripcion}
            name={item.id}
            className=''
            onChange={e => { getPlanesByCheckBoxHead(e, item) }}
            checked={item.checked}
            disabled={item.disabled}
        // defaultValue='1Play'
        // checked={true}
        />
    ))

    return (
        <div className={classMain}>
            <form
                className='c23Filter'
                onSubmit={handleSubmit(onSubmit)}
            >
                {/* Solo se muestra este campo en responsive */}
                <div className='c23FilterBlock c23FilterBlockTop'>
                    {/* <p>
                        Valores de todo el formulario de filtro:
                        { JSON.stringify( getValues())}
                    </p> */}
                    {/* <Title
                        tag={TitleTag.H2}
                        style={TitleStyle.H4}
                        className=''
                    >
                        Filtrar por
                    </Title> */}
                    <p className='h4'>Filtrar por</p>
                    <i className='ico-x' onClick={() => { setShowFilter(!showFilter) }}></i>
                </div>
                {
                    InputCheckSelectDataHead?.length > 1
                        ?
                        <div className='c23FilterBlock'>
                            <div className={`c23FilterBlockItems c23FilterBlockItemsShow c23FilterBlockItemsPlay`}>
                                <SimpleBar
                                    style={{ maxHeight: "200px" }}
                                >
                                    <div className='c23FilterBlockPlay'>
                                        {
                                            InputCheckSelectDataHead
                                        }
                                    </div>

                                </SimpleBar>
                            </div>
                        </div>
                        : null
                }
                <div className='c23FilterClear'>
                    <span>{counterFilters} filtros seleccionados</span>
                    <span className='c23FilterClearAct' style={{cursor:'pointer'}} onClick={(e) => { clearFilters(e, true); }}>Limpiar filtros</span>

                </div>
                {
                    counterFilters || familia === 'SHO' ? InputCheckSelectData : null
                }
                <div id="blockInternet" style={familia === 'SHO' ? {display:'none'}:{}} className={`c23FilterBlock ${familia !== 'SHO' ? 'c23FilterBlockBottom' : '' }`}>
                    <div className="c23FilterSubtitle">
                        <p>
                            Internet
                        </p>
                    </div>

                    <div className='c23FilterRangeBar'>
                        {/* <ProgressBar percentage={60}/> */}
                        <RangeSlider
                            min={rangePrice.min}
                            max={rangePrice.max}
                            onChange={v => handleChangePrice(v)}
                        />
                    </div>

                </div>
                
                { familia === 'SHO' &&
                <div className='c23FilterBlock c23FilterBlockBottom'>
                    <div className="c23FilterSubtitle">
                        <p>Ubicación</p>
                    </div>

                    <div className={`c23FilterBlockItems c23FilterBlockItemsShow`} >
                        <div className="c23FilterSelect">
                            <span> Ciudad </span>
                            <span className="select">
                                <select value={ciudad} onChange={(e) => {
                                    localStorage.setItem("ciudad", e.target.value)
                                    setCiudad(e.target.value)
                                    setCiudadText(e.target.options[e.target.selectedIndex].text)
                                    filterMulti(e.target.value, estrato)
                                }}>
                                    <option value="-1" disabled>Selecciona una Ciudad</option>
                                    {optionsCiudades}
                                </select>
                            </span>
                            {/* <Controller
                                render={({ field: { onChange, label } }) => (
                                    // <Select options={options} />
                                    <Dropdown
                                        options={dataRegiones}
                                        placeholder='Selecciona tu región'
                                        onChange={(selected) => {
                                            // React Select return object instead of value for selection
                                            onChange(selected);
                                            getComuna(selected);
                                            // clearComunaSelected({value:'', label:''});
                                        }}
                                    // onChange={(e) => {
                                    //     // onChange's arg will send value into hook form
                                    //     onChange(e.value);
                                    // }}

                                    >
                                        Región
                                    </Dropdown>
                                )}
                                control={control}
                                rules={{ required: false }}
                                name="region"
                                className='c23FilterSelect'
                            /> */}

                        </div>
                        <div className="c23FilterSelect">
                            <span> Estrato </span>
                            <span className="select">
                                <select value={estrato} onChange={(e) => {
                                    //console.log("modificando estrato a ", e.target.value)
                                    localStorage.setItem("estrato", e.target.value)
                                    setEstrato(e.target.value)
                                    setEstratoText(e.target.options[e.target.selectedIndex].text)
                                    filterMulti(ciudad, e.target.value)
                                }}>
                                    <option value="-1" disabled>Selecciona una estrato</option>
                                    {[
                                        {value: '1', label: 'Estrato 1'}, 
                                        {value: '2', label: 'Estrato 2'},
                                        {value: '3', label: 'Estrato 3'},
                                        {value: '4', label: 'Estrato 4'},
                                        {value: '5', label: 'Estrato 5'},
                                        {value: '6', label: 'Estrato 6'},
                                    ].map(item => (
                                        <option key={uuid()} value={item.value}>{item.label}</option>
                                    ))}

                                </select>
                            </span>

                            {/* <Controller
                                render={({ field: { onChange, label } }) => (
                                    // <Select options={options} />

                                    <Dropdown
                                        options={dataComunas}
                                        placeholder='Selecciona tu zona'
                                        onChange={(selected) => {
                                            // React Select return object instead of value for selection
                                            onChange(selected);
                                            getPlanesByComuna(selected);
                                        }}
                                    >
                                        Zona
                                    </Dropdown>
                                )}
                                control={control}
                                rules={{ required: false }}
                                name="zone"
                                className='c23FilterSelect'
                            /> */}
                        </div>



                    </div>
                </div>
                /*: 
                    <div className={`c23FilterBlock ${familia !== 'SHO' ? 'c23FilterBlockBottom' : '' }`}>
                        <div className="c23FilterSubtitle">
                            <p>
                                Internet
                            </p>
                        </div>

                        <div className='c23FilterRangeBar'>
                            {/* <ProgressBar percentage={60}/> }
                            
                                <RangeSlider
                                    min={rangeMb.min}
                                    max={rangeMb.max}          
                                    onChange={v=>handleChangeMb(v)}
                                />
                            
                        </div>

                    </div>*/
                }
            </form>
        </div>
    )
})

ServiceFilter.propTypes = {
    onSubmit: PropTypes.func,
    showFilter: PropTypes.bool,
    setShowFilter: PropTypes.func
}
ServiceFilter.defaultProps = {
    onSubmit: () => { },
    showFilter: true,
    setShowFilter: () => { },
}


function C23PersonasOrg() {
    // let history = useHistory();
    const [dataCPlanes, setdataCPlanes] = useState([])
    const [dataCPlanesBk, setdataCPlanesBk] = useState([])
    const [dataCPlanesBkHead, setdataCPlanesBkHead] = useState([])
    const [dataRegiones, setDataRegiones] = useState([])
    const [dataFilterTypes, setDataFilterTypes] = useState([])
    const [dataFilterTypes2, setDataFilterTypes2] = useState([])
    const [dataFilterTypesBK, setDataFilterTypesBk] = useState([])
    const [dataFilterTypesHead, setDataFilterTypesHead] = useState([])
    const [dataFilterOptions, setDataFilterOptions] = useState([])
    const [inputSearch, setinputSearch] = useState('')
    const [optionFilter, setOptionFilter] = useState('')
    const [rangePriceState, setRangePriceState] = useState(localStorage.getItem("id_familia") === 'SHO' ? { min: 0, max: 1000 } : { min: 0, max: 150 })
    const [rangeMbState, setRangeMbState] = useState({ min: 5, max: 1000 })
    const [showFilter, setShowFilter] = useState(true)
    const [offset, setOffset] = useState(0)
    const [pageCount, setPageCount] = useState(1)
    const [perPage, setPerPage] = useState(6)
    const [dataToItems, setDataToItems] = useState([])
    const [counterFilters, setCounterFilters] = useState(0)
    const [counterFiltersHead, setCounterFiltersHead] = useState(0)
    const [preFilterRemove, setPreFilterRemove] = useState(true)
    //const [caracteristicaPostPago, setCaracteristicaPostPago] = useState([])
    const [postPagoCarac, setPostPagoCarac] = useState([])
    const [postPagoCaracFull, setPostPagoCaracFull] = useState([])
    const [filterPostPago, setFilterPostPago] = useState(null)
    const [familia, setFamilia] = useState('')
    const [ciudadFil, setCiudadFil] = useState('-1')
    const [estratoFil, setEstratoFil] = useState('-1')
    const [ciudadText, setCiudadText] = useState('')
    const [estratoText, setEstratoText] = useState('')
    const [dataCiudades, setDataCiudades] = useState([])
    const [dataCiudadesLogic, setDataCiudadesLogic] = useState([])
    const [dataGenAccordion, setDataGenAccordion] = useState([])
    const [keysPlanCompare, setKeysPlanCompare] = useState([])
    const [regresaPlanes, setRegresaPlanes] = useState(false)

    //Ultimo tipo necesidad
    const [filtrosRemover] = useState([-1,37])
    const [filtros] = useState({
        servicios: 1,
        plataformasStreaming: 5,
        plataformasStreamingPostpago: 11,
        telefoniaFija: 12,
        internet: 13,
        television:14,
    })


    /*async function getMinMaxPrice(dataArrayBk = null) {
        // console.log("Calculate range price min and max***********", dataArray)
        if (!dataArrayBk?.length) {
            //console.log("Calculate range price min and max if ***********", dataArrayBk)
            // return { min: 0, max: 20000 }
            await setRangePriceState({ min: 0, max: 20000 })
        } else {
            // console.log("Calculate range price min and max else***********", dataArray)
            let dataArray = dataArrayBk
            /*dataArray.sort(function (a, b) {
                return a.fi_PRECIO_PLAN - b.fi_PRECIO_PLAN
            }
            let min = dataArray[0].fi_PRECIO_PLAN;
            let max = dataArray[dataArray.length - 1].fi_PRECIO_PLAN;
            //console.log("Calculate range price min and max___________________________________", min, max)
            await setRangePriceState({ min: min, max: max })
        }
    }*/

    async function  getMinMaxMb(dataArray = null) {
        if (!dataArray?.length) {
            //console.log("Calculate range mb min and max if ***********")
            // return { min: 0, max: 20000 }
            let minMax = {
                min: 0,
                max: 1000
            }
            await setRangePriceState(minMax)
        } else {
            let navegacion = dataArray.filter(d => d.fi_VELOCIDAD_INTERNET)
            
            
            navegacion.sort(function (a, b) {
                return a.fi_VELOCIDAD_INTERNET - b.fi_VELOCIDAD_INTERNET
            })
            console.log("navegacion", navegacion)
            let minv = navegacion[0].fi_VELOCIDAD_INTERNET;
            let maxv = navegacion[navegacion.length - 1].fi_VELOCIDAD_INTERNET;
            //console.log("Calculate range mb min and max___________________________________", minv, maxv)
            let minMax  = {
                min: minv, max: maxv
            }
            await setRangePriceState(minMax)
        }
    }

    async function getCiudades() {
        // console.log("dataComuna********************************", selected.target.value, selected.value)
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        const configGetCiudades = {
            method: 'POST',
            url: url_servicio_web + "listaCiudades",
            data: JSON.stringify(0),
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },

        };
        let response = await axios(configGetCiudades)
        
        //console.log("response- configGetCiudades------------------------->", response);
        setDataCiudades(response.data)
        if(response.data){
            let ciudadId = localStorage.getItem("ciudad")
            let estratoId = localStorage.getItem("estrato")
            let ciudad = response.data.find(c => c.fi_ciudad.toString() === ciudadId)
            setCiudadFil(ciudad ? ciudad.fi_ciudad.toString() : '-1')
            setCiudadText(ciudad ? ciudad.fc_descripcion : '')
            setEstratoFil(estratoId ? estratoId : '-1')
            setEstratoText(estratoId ? `Estrato ${estratoId}` : '')
        }
    }

    async function getCiudadesByFamilia() {
        // console.log("dataComuna********************************", selected.target.value, selected.value)
        
        let url_servicio_web = localStorage.getItem('url_servicio_web_plan')
        const configGetCiudades = {
            method: 'POST',
            url: url_servicio_web + "listaCiudades",
            data: JSON.stringify(0),
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },

        };
        let response = await axios(configGetCiudades)
        
        //console.log("response- configGetCiudades------------------------->", response);
        setDataCiudadesLogic(response.data?.lstCiudades)
        
    }

    async function getDataGenAccordion() {
        // console.log("getDataGenAccordion ********************************")
        let url_servicio_web = localStorage.getItem('url_accordion')
        if (url_servicio_web){
            const configGetAccordion = {
                method: 'GET',
                url: url_servicio_web,
                data: JSON.stringify(0),
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': "text/html;",
                    'Content-Type': "text/html;"
                },
    
            };
            let response = await axios(configGetAccordion)
            let bodyHtml = response.data
            bodyHtml = bodyHtml.split("<body")[1].split(">").slice(1).join(">").split("</body>")[0];
            // console.log("response- configGetAccordion------------------------->", bodyHtml);
            setDataGenAccordion(bodyHtml)
        }
    }

    async function getCPlanes() {
        //console.log("dataCPlanes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        //let url_servicio_web = 'https://backoffice-ng.amx-dev.clarodigital.net/api/CO_MS_BE_CRN_PLANES_POSTPAGO'
        let id_familia = localStorage.getItem('id_familia')
        setFamilia(id_familia)
        //let id_familia = 'SHO'
        const configCPlanes = {
            method: 'GET',
            url: url_servicio_web + "get_cplanes?fi_familia=" + id_familia,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCPlanes)
        //console.log("response- getCPlanes------------------------->", response);
        
        if(response.data){
            let dataPlanArray = response.data;
            let newDataPlanArray = dataPlanArray.map((p, index)=>{
                
                const newCaractData = p.caracteristicas.filter(function (CaracData) {
                    let CaracValor = CaracData?.fc_VALOR.toLowerCase()
                    return CaracValor.toLowerCase().indexOf("gb") > -1 && CaracValor.indexOf(" ") < 0
                })
                
                if(newCaractData?.length > 0){
                    let byteSplitGB = parseInt( newCaractData[0].fc_VALOR.toLowerCase().split("gb")[0] )
                    if(byteSplitGB && p?.fi_VELOCIDAD_INTERNET !== byteSplitGB && p?.fi_ID_DASHBOARD && p?.fc_CRC === "postpago" ){
                        p.fi_VELOCIDAD_INTERNET = byteSplitGB
                        console.log("byteSplit newCaractData:::: fi_PLAN:", p.fi_PLAN, "fi_VELOCIDAD_INTERNET: ", p.fi_VELOCIDAD_INTERNET, "Caract new GB: " , byteSplitGB, "fi_ID_DASHBOARD:" , p.fi_ID_DASHBOARD)
                    }

                }
                // console.log("newCaractData:::::::::::::::_____", p.fi_PLAN, newCaractData, newCaractData?.length)
                return p;
            })
            // console.log("newArrayPlanes-------------------", newDataPlanArray)
            let estratoId = localStorage.getItem("estrato")
            let ciudadId = localStorage.getItem("ciudad")
            let familiaId = localStorage.getItem("id_familia")
            let planes = newDataPlanArray.filter(p => 
                p.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === estratoId)
            &&  
            (p.fi_TODO_CIUDAD === 1 
                ? !p.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === ciudadId) 
                : p.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === ciudadId)))
            let pageCountVal = planes ? (Math.ceil(planes.length / perPage)) : 1
            let planesOrden = familiaId === 'SHO' ? planes : newDataPlanArray
            planesOrden.sort((a, b) => getCalculateEstrato(b).fi_ORDEN - getCalculateEstrato(a).fi_ORDEN);
            console.log("planes===>",planesOrden)

            setdataCPlanes(planesOrden)
            setPageCount(pageCountVal)
            await setdataCPlanesBk(planesOrden)
            setdataCPlanesBkHead(planesOrden)
            //getMinMaxPrice(response.data)
            getMinMaxMb(planesOrden)
            setPerPage(6)
        } 
        
        
    }

    async function getCaractPostPago() {
        //console.log("getCaractPostPago********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        //let url_servicio_web = 'https://backoffice-ng.amx-dev.clarodigital.net/api/CO_MS_BE_CRN_PLANES_POSTPAGO'
        // let id_familia = localStorage.getItem('id_familia')
        //let id_familia = 'SHO'
        const configCaractPostPago = {
            method: 'GET',
            url: url_servicio_web + "CaracteristicaPostPago",
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCaractPostPago)
        // console.log("response- getCaractPostPago------------------------->", response);
        //await setCaracteristicaPostPago(response.data)
        setPostPagoCaracFull(response.data)
        handleChangeFilterPostPago(response.data);
    }

    async function getRegiones() {
        // console.log("getRegiones********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        const configRegiones = {
            method: 'POST',
            url: url_servicio_web + "listaDepartamentos",

        };
        let response = await axios(configRegiones)
        let Regiones = []
        //console.log("response- getRegiones------------------------->", response);
        response.data.forEach(element => {
            Regiones.push({ value: element.fi_departamento, label: element.fc_descripcion })
        });
        setDataRegiones(Regiones)
    }

    async function getFilterTypes() {
        // console.log("getFilterTypes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fc_familia = localStorage.getItem('id_familia')
        const configRegiones = {
            method: 'GET',
            url: url_servicio_web + "get_FilterTypes?fc_familia=" + fc_familia,
        };
        let response = await axios(configRegiones)
        let FilterTypes = [] //, elements = {}
        //console.log("response- getFilterTypes------------------------->", response);
        let FilterTypes2 = [] 
        response.data.forEach(dfilt => {
            let value = { 
                id: dfilt.fi_OPCION_FILTRO, 
                fi_FILTRO: dfilt?.fi_FILTRO, 
                Descripcion: dfilt.fc_DESCRIPCION, 
                checked: false, 
                lstHijos: dfilt.lstHijos,
                tipo: dfilt.fc_DESCRIPCION
            }
                
            if(FilterTypes2.find(f => f.name === dfilt.fc_NOMBRE && f.idFil === dfilt.fi_FILTRO)){
                let listFilter = FilterTypes2.find(f => f.name === dfilt.fc_NOMBRE && f.idFil === dfilt.fi_FILTRO).value
                listFilter.push(value)
            } else {
                let listFilter = []
                listFilter.push(value)
                let val = {
                    name: dfilt.fc_NOMBRE,
                    idFil: dfilt.fi_FILTRO,
                    value: listFilter
                }
                FilterTypes2.push(val)
            }
            FilterTypes.push({ id: dfilt.fi_OPCION_FILTRO, fi_FILTRO: dfilt?.fi_FILTRO, Descripcion: dfilt.fc_DESCRIPCION, checked: false })
        });
        //console.log("setDataFilterTypes--------------", FilterTypes2)
        setDataFilterTypes2(FilterTypes2)
        setDataFilterTypes(FilterTypes)
        setDataFilterTypesBk(FilterTypes)
    }

    async function getFilterTypesHead() {
        // console.log("getFilterTypes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fc_familia = localStorage.getItem('id_familia')
        const configRegiones = {
            method: 'GET',
            url: url_servicio_web + "get_HeadFilterTypes?fc_familia=" + fc_familia,
        };
        let response = await axios(configRegiones)
        let FilterTypesHead = [] //, elements = {}
        //console.log("response- getFilterTypesHead------------------------->", response);

        response.data.forEach(dfilt => {
            FilterTypesHead.push({ id: dfilt.fi_FILTRO, Descripcion: dfilt.fc_DESCRIPCION, checked: false, disabled: false })
        });
        // console.log("setDataFilterTypes", FilterTypes)
        setDataFilterTypesHead(FilterTypesHead)
    }

    async function getFilterOptions() {
        // console.log("getFilterOptions********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let fc_familia = localStorage.getItem('id_familia')
        const configRegiones = {
            method: 'GET',
            url: url_servicio_web + "get_FilterOptions?fc_familia=" + fc_familia,

        };
        let response = await axios(configRegiones)
        let FilterOptions = [] //, elements = {}
        //console.log("response- getFilterOptions------------------------->", response);

        response.data.forEach(dfilt => {
            FilterOptions.push({ value: dfilt.fi_OPCION_FILTRO, label: dfilt.fc_DESCRIPCION })
        });
        setDataFilterOptions(FilterOptions)
        //console.log("setDataFilterOptions", dataFilterOptions)
    }

    const handleChangeFilterPrice = (el) => {
        const result = Object.values(el);
        console.log("handleChangeFilterPrice.......", result);
        setRangePriceState({ min: result[0], max: result[1] })
        getFilterPlansByPrices(result[0], result[1])

    }

    const handleChangeFilterMb = (el) => {
        
        const result = Object.values(el);
        console.log("handleChangeFilterMb.......", result);
        setRangeMbState({ min: result[0], max: result[1] })
        getFilterPlansByMb(result[0], result[1])
    }

    const handleChangeFilterPostPago = (CaracteristicaPostPago, idTipoNecesidad = null) => {
        let idFilterPostPago = idTipoNecesidad ? idTipoNecesidad : 4
        // const result = Object.values(el);
        console.log("handleChangeFilterPostPago.......", CaracteristicaPostPago, idTipoNecesidad, idFilterPostPago);
        setFilterPostPago(idFilterPostPago)
        const data = CaracteristicaPostPago?.length ? CaracteristicaPostPago : [];
        const newCaractData = data.filter(function (CaracData) {
            let TIPO_NECESIDAD = []

            TIPO_NECESIDAD = CaracData.fi_TIPO_NECESIDAD
            // console.log("to search---------- caracteristicaPostPago: filter ", CaracData)
            return TIPO_NECESIDAD === idFilterPostPago
            // return TIPO_NECESIDAD
        })
        setPostPagoCarac(newCaractData)
        // console.log("to search---------- caracteristicaPostPago: newCaractData ", newCaractData, data)
        // return newCaractData
    }

    const getPlanesByCheckBox = (el, item = null) => {
        console.log("getPlanesByCheckBox:::::::", item)
        console.log("getPlanesByCheckBox: ", el.target.type, el.target, item?.tipo, item, dataFilterTypes2)
        if (el.target.type === "radio"){
            let arrayNecesidad = []
            arrayNecesidad[31]=4;
            arrayNecesidad[32]=3;
            arrayNecesidad[33]=2;
            arrayNecesidad[34]=1;
            console.log("el.target.type: ", arrayNecesidad)
            handleChangeFilterPostPago(postPagoCaracFull, arrayNecesidad[item.id])
        }
        if(item?.tipo === 'Internet'){
            
            let el = document.getElementById('blockInternet')
            if(!item.checked){
                el.removeAttribute("style")
                rangePrice={min:5,max:10}
                setRangePriceState({min:5,max:10})
            } else{
                el.setAttribute("style","display:none")
                rangePrice={min:5,max:10}
                setRangePriceState({min:5,max:10})
            }
        }
        let isCheck = el.target.checked
        if(item?.lstHijos && !isCheck){
            item.lstHijos.forEach(f => {
                f.checked = false
            })
        }
        let countVal = 0
        dataFilterTypes2.forEach(f => {
            if(f.idFil === serviciosId){
                countVal = f.value.filter(v => v.checked).length
            }
            if(countVal < 3 && f.idFil === plataformasStreamingId){
                f.value.forEach(s => {
                    s.checked = false
                })
            }
            if(f.name === "Planes"){
                f.value.forEach(v => {
                    v.checked = false
                })
            }
        })
        
        item.checked = isCheck 
        
        // item.checked = isCheck
        console.log("getPlanesByCheckBox: ", dataFilterTypes2)
        getFilterPlansMulti2(inputSearch, ciudadFil, estratoFil, rangeMb)
    }

    const getPlanesByCheckBoxHead = (el, item) => {
        
        let isCheck = el.target.checked
        //let idFiltro = parseInt(el.target.name)
        item.checked = isCheck
        let newArrayChecks = dataFilterTypesHead.map((filt, index) => {
            if (filt.id === item.id) {
                filt.checked = isCheck
                return filt;
            } else {
                // filt.disabled = isCheck
                filt.checked = !isCheck
                return filt;
            }        
        })
        setDataFilterTypesHead(newArrayChecks)
        //console.log("getPlanesByCheckBoxHead isCheck: ", isCheck, "idFiltro: " + idFiltro, item, dataFilterTypesHead, newArrayChecks);
        // getFilterPlansMulti(rangePriceState, dataFilterTypes, filterComuna, optionFilter, inputSearch)
        if (isCheck) {
            getDataFilterTypes(item.id)
        } else {
            getDataFilterTypes()
        }
    }

    const getDataFilterTypes = (idFiltro = null) => {
        let newArrayChecks = []
        if (idFiltro !== null) {
            clearFilters(null, false)
            newArrayChecks = dataFilterTypesHead.filter(filt => filt.id === idFiltro);
            getFilterPlansByPlay(newArrayChecks)
            setCounterFiltersHead(1)
        } else {
            newArrayChecks = dataFilterTypesBK
            clearFilters(null, true)
            setCounterFiltersHead(0)
        }
        //setDataFilterTypes(newArrayChecks)
        console.log("getDataFilterTypes isCheck: ", "idFiltro: " + idFiltro, dataFilterTypes, newArrayChecks);

    }

    /*const getPlanesByComuna = (el) => {
        //console.log("getPlanesByComuna---------------------", el, el.target.value);
        let valComuna = el.target.value.split("_")[1]
        setFilterComuna(valComuna)
        getFilterPlansByComuna(valComuna)
    }*/

    const onChangeFilterOptions = (e) => {
        //console.log("sort ", e.target.value)
        let val = e.target.value
        setOptionFilter(val)
        //getFilterPlanesByOptions(val)
        let option = e.target.value
        let list = dataCPlanes?.length ? dataCPlanes : []
        if(option && (option === '4' || option === '22')){
            //console.log("sort 1")
            list.sort((a, b) => (getCalculateEstrato(b).fi_PRECIO_PLAN > getCalculateEstrato(a).fi_PRECIO_PLAN) ? 1 : -1)
            setdataCPlanes(list)
        } else if(option && (option === '5' || option === '65')){
            //console.log("sort 2")
            list.sort((a, b) => (getCalculateEstrato(a).fi_PRECIO_PLAN > getCalculateEstrato(b).fi_PRECIO_PLAN) ? 1 : -1)
            setdataCPlanes(list)
        }


        //console.log("onChangeFilterOptions---------------------", val);
    }

    const handleChangeCompare = (el) => {
        let isCheck = el.target.checked
        let planId = parseInt(el.target.name)
        //console.log("handleChangeCompare isCheck: " + isCheck, "planId:" + planId);
        if (isCheck) {
            const exist = keysPlanCompare.filter((id) => id === planId);
            if (!exist.length) {
                setKeysPlanCompare([...keysPlanCompare, planId])
            }
        } else {
            let newarray = keysPlanCompare.filter(element => element !== planId);
            setKeysPlanCompare(newarray)
        }
    }

    const resetHandleClick = (el) => {

        //console.log("resetHandleClick: " + el);
        setKeysPlanCompare([])
        setDataToItems([])
    }
    function clearFilters(e, clearHead = true) {
        //console.log("clearFilters: ", e);
        setinputSearch('')
        setOptionFilter('')
        //setFilterComuna('')
        // setDataFilterOptions([])
        setOptionFilter('')
        setCounterFilters(0)
        setCounterFiltersHead(0)

        setRangePriceState({min:1, max:2})

        if(familia === 'SHO'){
            let el = document.getElementById('blockInternet')
            el.setAttribute("style","display:none")
        }
        
        let list = dataCPlanesBk?.filter(p => 
            p.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === estratoFil)
        && (p.fi_TODO_CIUDAD === 1 
            ? !p.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === ciudadFil) 
            : p.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === ciudadFil)))
        let listOrden = familia === 'SHO' ? list : dataCPlanesBkHead
        listOrden.sort((a, b) => (getCalculateEstrato(a).fi_PRECIO_PLAN > getCalculateEstrato(b).fi_PRECIO_PLAN) ? 1 : -1)
        //console.log("databkkkkk",familia,list)
        setdataCPlanes(listOrden)
        //setdataCPlanesBk(dataCPlanesBkHead)

        let pageCountVal = dataCPlanesBkHead.length ? (Math.ceil(dataCPlanesBkHead.length / perPage)) : 1;
        setOffset(0)
        setPageCount(pageCountVal)
        let newArrayChecks = dataFilterTypes.map((filt, index) => {
            if (filt.id) {
                filt.checked = false
            }
            return filt;
        })
        let newArrayChecks2 = dataFilterTypes2.map((filt, index) => {
            filt.value?.forEach((subfilt) => {
                if (subfilt.id) {
                    subfilt.checked = false
                }
                
            })
            return filt;
        })
        setDataFilterTypes2(newArrayChecks2)
        setDataFilterTypes(newArrayChecks)
        console.log("clearFilters: ", newArrayChecks, newArrayChecks2);
        if (clearHead) {
            let newArrayChecksHead = dataFilterTypesHead.map((filt, index) => {
                if (filt.id) {
                    filt.checked = false
                    filt.disabled = false
                }
                return filt;
            })
            setDataFilterTypesHead(newArrayChecksHead)
        }
        //console.log("clearFilters: end: ", e);
    }

    function removeItemHandleClick(el) {
        console.log("removiendo", el)
        let idPlanRemove = parseInt(el.fi_PLAN)
        if (idPlanRemove) {
            let newarray = keysPlanCompare.filter(element => element !== idPlanRemove);
            // setKeysPlanCompare(newarray)
            //console.log("removeItemHandleClick: " + el.target, "id: " + el.target.id, "name: " + el.target.name, idPlanRemove, newarray);
            setKeysPlanCompare(newarray)
            let dataToItems = dataCPlanesBk.filter(f => newarray.includes(f.fi_PLAN));
            let arrayItemes = { items: dataToItems }
            //console.log("dataToItems::::::::::::::::::::" + dataToItems, arrayItemes, keysPlanCompare.length);
            setDataToItems(arrayItemes)
        }
        // setDataToItems([])
    }

    function onChangeInputSearch(e) {
        //console.log("onChangeInputSearch", e.target.value)
        let textValue = e.target.value
        if (textValue.length) {
            setinputSearch(textValue)
            
        } else {
            setCounterFilters(counterFilters > 0  ? counterFilters - 1 : counterFilters)
            let list = dataCPlanesBk?.filter(p => 
                p.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === estratoFil)
            && (p.fi_TODO_CIUDAD === 1 
                ? !p.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === ciudadFil) 
                : p.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === ciudadFil)))
            //console.log("mostrando lista",list, estratoFil, ciudadFil)
            if(optionFilter && optionFilter === '4'){
                //console.log("sort 1")
                list.sort((a, b) => (getCalculateEstrato(b).fi_PRECIO_PLAN > getCalculateEstrato(a).fi_PRECIO_PLAN) ? 1 : -1)
                
            } else if(optionFilter && optionFilter === '5'){
                //console.log("sort 2")
                list.sort((a, b) => (getCalculateEstrato(a).fi_PRECIO_PLAN > getCalculateEstrato(b).fi_PRECIO_PLAN) ? 1 : -1)
                
            }
            

            setdataCPlanes(list)
            let pageCountVal = list.length ? (Math.ceil(list.length / perPage)) : 1;
            setOffset(0)
            setPageCount(pageCountVal)
            
        }
    }

    function getFilterPlansByMb(min, max) {
        let r = { min: min, max: max }
        getFilterPlansMulti2(inputSearch, null, null, r)
    }

    function getFilterPlansByPrices(min, max) {
        console.log("function getFilterPlansByPrices***********", min, max)
        let r = { min: min, max: max }
        getFilterPlansMulti2(inputSearch,ciudadFil,estratoFil,r)
        // let data = dataCPlanes.length ? dataCPlanes : [];

        // let newDataFilter = data.filter((plan, index) => {
        //     // console.log("getFilterPlans... filter:", index, min, max, plan.fi_PRECIO_PLAN)
        //     // console.log("getFilterPlans... filter:", index, min + " es mayor " + mayor, max + " es menor " + menor, plan.fi_PRECIO_PLAN)
        //     return ((plan.fi_PRECIO_PLAN >= min) === true && (plan.fi_PRECIO_PLAN <= max) === true);
        // });
        // console.log("getFilterPlansByPrices....------", newDataFilter)
        // let list = newDataFilter
        // list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)

        // let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        // setdataCPlanes(list)
        // // getMinMaxPrice()
        // // handlePageClick({selected: 0})
        // setPageCount(pageCountVal)
        // setOffset(0)
        // console.log("to search---------- getFilterPlansByPrices:", pageCountVal, newDataFilter, newDataFilter.length)
    }

    /*function getFilterPlansByComuna(fc_TIPO_DISPONIBILIDAD) {
        console.log("getFilterPlansByComuna***********", fc_TIPO_DISPONIBILIDAD)
        getFilterPlansMulti(rangePriceState, dataFilterTypes, fc_TIPO_DISPONIBILIDAD, optionFilter, inputSearch, inputSearch, null, null, rangeMbState)
        // let data = dataCPlanes.length ? dataCPlanes : [];

        // let newDataFilter = data.filter((plan, index) => {
        //     return plan.fc_TIPO_DISPONIBILIDAD === fc_TIPO_DISPONIBILIDAD;
        // });
        // console.log("getFilterPlansByComuna....------", newDataFilter)
        // let list = newDataFilter
        // list.sort((a, b) => (a.fi_PLAN > b.fi_PLAN) ? 1 : -1)

        // let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        // setdataCPlanes(list)
        // setPageCount(pageCountVal)
        // setOffset(0)
        // console.log("---------- getFilterPlansByComuna:", pageCountVal, newDataFilter, newDataFilter.length)
    }*/

    function getFilterPlansByPlay(dataFilterTypesData) {
        let data = dataCPlanesBkHead?.length ? dataCPlanesBkHead : []
        let newDataFilter = data.filter((data, index) => {
            let flagCheck = -1;
            let arraykeyCheck = []
            dataFilterTypesData.map((filt, index) => {
                if (filt.id) {
                    arraykeyCheck.push(filt.id)
                }
                return filt
            })

            let isExist = false
            data.lstFiltrosxPlan.map(option => {
                let isSameId = arraykeyCheck.find( c => c === option.fi_OPCION_FILTRO || c.toString() === option.fc_VALOR)
                if (isSameId) isExist = true
                return isExist
            })
            if (isExist) {
                flagCheck = 1
            }

            // console.log("check if getFilterPlansByPlay*********** CheckedsBox: isExist", isExist, CheckedsBox, result)
            if (flagCheck > -1) {
                //console.log("FLAGS-------------", flagCheck, data, arraykeyCheck, result, CheckedsBox)
                return data
            } else {
                return null
            }
        })
        let list = newDataFilter

        list.sort((a, b) => (a.fi_PRECIO_PLAN > b.fi_PRECIO_PLAN) ? 1 : -1)
        //console.log("to search---------- getFilterPlansByPlay:", dataCPlanesBkHead, newDataFilter, newDataFilter.length)
        let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        //setdataCPlanesBk(list)
        // getMinMaxPrice()
        setOffset(0)
    }

    function getFilterPlansMulti2( input = null, ciudad = null, estrato = null, rangeMb = null) {
        let data = dataCPlanesBk.length ? dataCPlanesBk : [];
        let ContaFilter = 0
        //console.log("validando input", input)

        let check = []
        let checkHead = []
        let padresTotales = []

        
                if(familia === 'SHO'){
                    dataFilterTypes2.forEach( filt => {
                        filt.value?.forEach(f1 =>{
                            if(f1.fi_FILTRO === filtros.servicios){
                                padresTotales.push({id:f1.id})
                            }
                            
                            if(f1.checked && f1.fi_FILTRO === filtros.servicios){
                                check.push({id:f1.id, padre:true})
                            } else if(f1.checked && f1.fi_FILTRO === filtros.plataformasStreaming){
                                check.push({id:f1.id})
                            }
                            if(f1.lstHijos){
                                let flagHijo = f1.lstHijos.find(f2 => f2.checked)
                                f1.lstHijos.forEach(f2 => {
                                     
                                    if(f1.checked && !flagHijo){
                                        check.push({id:f2.fi_OPCION_FILTRO, hijo:true})
                                    } else if(f2.checked) {
                                        check.push({id:f2.fi_OPCION_FILTRO})
                                    }
                                })
    
                            }
                        })            
                    })
                } else {
                    dataFilterTypes2.forEach( filt => {
                        filt.value?.forEach(f1 =>{
                            if(f1.fi_FILTRO === filtros.servicios){
                                padresTotales.push({id:f1.id})
                            }
                            
                            if(f1.checked && f1.fi_FILTRO === filtros.plataformasStreamingPostpago){
                                check.push({id:f1.id})
                            } else if(f1.checked){
                                check.push({id:f1.id, padre:true})
                            }

                            if(f1.lstHijos){
                                let flagHijo = f1.lstHijos.find(f2 => f2.checked)
                                f1.lstHijos.forEach(f2 => {
                                     
                                    if(f1.checked && !flagHijo){
                                        check.push({id:f2.fi_OPCION_FILTRO, hijo:true})
                                    } else if(f2.checked) {
                                        check.push({id:f2.fi_OPCION_FILTRO})
                                    }
                                })
                            }
                        })        
                    })
                }
                

                
                dataFilterTypesHead.forEach(f => {
                    if(f.checked){
                        checkHead.push({id:f.id})
                    }
                })

                let hijoSeleccionado = check.filter(c => !c.padre)
                console.log("hijoSeleccionado", hijoSeleccionado)


                let padreSeleccionado = check.filter(c => c.padre)
                console.log("padreSeleccionado", padreSeleccionado)

                let padresSin = padresTotales.filter(p => !padreSeleccionado.find(s => s.id === p.id))
                console.log("padresSin", padresSin)
                

        let newDataFilter = data.filter((data, index) => {
            let flagInput = -1
            if (input && input.length) {
                //console.log("input if getFilterPlansMulti***********", "input: " + input)
                ContaFilter = 1
                for (let [key, value] of Object.entries(data)) {

                    if (key === "caracteristicas" && value.length) {
                        for (let [keyC, valueC] of Object.entries(value)) {
                            // let valueCS = String(value)

                            if (valueC.fc_TITULO.toLowerCase().search(inputSearch.toLowerCase()) > -1 || valueC.fc_VALOR.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                                console.log("------------------caracteristicas index:" + index, keyC, valueC.fc_TITULO.toLowerCase(), valueC.fc_VALOR.toLowerCase(), inputSearch.toLowerCase());
                                flagInput = index
                            }
                        }
                    } else {
                        let valueS = String(value)
                        // //console.log("------------------ index:"+index, valueS.toLowerCase(), inputSearch.toLowerCase());
                        if (valueS.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                            //console.log("------------------ index:" + index, key, valueS.toLowerCase());
                            flagInput = index
                        }
                    }
                }
            } else {
                flagInput = 1
            }

            let flagCheck = -1
            if (check) {
                
                
               
                
                
                /*console.log("lstFiltrosPlan", data.lstFiltrosxPlan)
                
                let filtrosPendiente = data.lstFiltrosxPlan.filter(f => 
                    !filtrosRemover.includes(f.fi_OPCION_FILTRO) 
                    && !padreSeleccionado.find(s => s.id === f.fi_OPCION_FILTRO) )
                console.log("filtrosPendientes" + data.fi_PLAN, filtrosPendiente)
                                
                if(!filtrosPendiente.length){
                    console.log("filtroPendiente")
                    flagCheck = 1                   
                }

                if(!padresSin.length){
                    console.log("padreSin")
                    flagCheck = 1
                }

                padreSeleccionado.forEach(p => {
                    if(!data.lstFiltrosxPlan.find(f => f.fi_OPCION_FILTRO === p.id)){
                        console.log("noLista")
                        flagCheck = -1
                    }
                })*/








                //Valida si de los filtros seleccionados se encuentra               
                data.lstFiltrosxPlan.forEach(option => {
                    let isSameId = check.length ? check.find(a => (a.id === option.fi_OPCION_FILTRO || a.id.toString() === option.fc_VALOR)) : false
                    if (isSameId) {
                        flagCheck = 1
                    }
                })
                
                              
                if(check && flagCheck > -1 && familia === 'SHO'){


                    /*console.log("padresTotales ", padresTotales)

                    let padres = check.filter(c => c.padre)

                    let padresRes = padresTotales.filter(c => {
                        return !padres.find(p => c.id === p.id)
                    }) 
                    padresRes =
                    data.lstFiltrosxPlan.filter( r=> padresRes.find(p=> p.id === r.fi_OPCION_FILTRO))
                    let hijos = check.filter(c => c.hijo || !c.padre)
                    
                    let listaFiltroPLan = data.lstFiltrosxPlan.filter(f => {
                        return !megasValue.find( m => m === f.fi_OPCION_FILTRO)
                    })
                    console.log("padresRes ", padresRes)
                    /*console.log("Contenido de listas", padres.length,
                    JSON.stringify(hijos.sort((a,b) => a.id - b.id)), 
                    JSON.stringify(listaFiltroPLan.sort((a,b) => a.fi_OPCION_FILTRO - b.fi_OPCION_FILTRO)))


                    if(padres.length === 1 && hijos.length ){
                        if(padresRes.length > 0){
                            flagCheck = -1
                        }
                    } else if(padres.length === 2){
                        if(!hijos){

                        }
                    }*/

                    //Filtro para remover megas
                    let filts = data.lstFiltrosxPlan.filter( d => {
                        return !filtrosRemover.find(m => m === d.fi_OPCION_FILTRO)
                    }).map(d => {return d.fi_OPCION_FILTRO})
                                        
                    let padrePendiente = filts.filter( f => padresSin.find(p => p.id === f))
                    if(padrePendiente.length){
                        if(data.fi_PLAN === 18){
                            console.log("padre pendiente", padrePendiente)
                        }
                        flagCheck = -1
                    } 

                    let newCheck = check.filter(c => c.padre).map( c => {return c.id})
                    let filtPadre = filts.filter(f => padresTotales.find(p => p.id === f))
                    if(newCheck.length > 1 && JSON.stringify(filtPadre.sort((a,b) => a - b)) !== JSON.stringify(newCheck.sort((a,b) => a.id - b.id))){
                        flagCheck = -1
                    }
                    
                    
                    if(hijoSeleccionado.filter(h => !h.hijo).length){
                        console.log("hijoseleccionado ", data.fi_PLAN, hijoSeleccionado, filts )

                        if(!filts.find(f => hijoSeleccionado.find(p => p.id === f))){
                            console.log("sinhijoseleccionado")
                            flagCheck = -1
                        }
                    }

                    //console.log("newCheck ",data.fi_PLAN, newCheck, filts)
                    //Validación para 2Play o 3Play
                    /*if((newCheck.length === 1 || newCheck.length === 2) && JSON.stringify(filts.sort((a,b) => a - b)) !== JSON.stringify(newCheck.sort((a,b) => a.id - b.id))){
                        flagCheck = -1                        
                    } else if ((newCheck.length > 1 && filts.length === 1) || (newCheck.length > 2 && filts.length === 2) ){
                        flagCheck = -1
                    }*/

                    
                }
            }

            let flagMb = -1
            if(rangeMb){
                let id_familia = localStorage.getItem('id_familia')
                const newCaractData = data.caracteristicas.filter(function (CaracData) {
                    let idWS = 0
                    let CaracTitulo = CaracData?.fc_TITULO.toLowerCase();
                    let CaracValor = CaracData?.fc_VALOR.toLowerCase()
                    idWS = CaracData.fi_CARACTERISTICA_WS.toString()
                    let newCaracToShowTitle = postPagoCarac.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})
                    if (filterPostPago && id_familia !== 'SHO'){
                        if (newCaracToShowTitle !== undefined){
                            CaracTitulo = newCaracToShowTitle?.fc_TEXTO_MOSTRAR?.toLowerCase()
                        }
                    }
                    
                    
                    return CaracTitulo.indexOf("datos incluidos") > -1 && CaracValor.indexOf("ilimitada") > -1
                })
                // let dataToCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC !== 0));
                if(data.fi_VELOCIDAD_INTERNET >= rangeMb.min && data.fi_VELOCIDAD_INTERNET <= rangeMb.max){
                    flagMb = 1
                }
                if(newCaractData?.length > 0){
                    console.log("newCaractData::: datos ilimitados: fi_PLAN:", data.fi_PLAN, newCaractData?.length, newCaractData, data.caracteristicas)
                    flagMb = 1
                }
            }
            if(!data.fi_VELOCIDAD_INTERNET){
                flagMb = 1
            }
            
            let flagCiudad = -1
            if (data.fi_TODO_CIUDAD === 1){
                if(!data.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === (ciudad ? ciudad : ciudadFil))){
                    flagCiudad = 1
                }
            } else {
                if (data.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === (ciudad ? ciudad : ciudadFil))){
                    flagCiudad = 1
                }
            }

            if(familia !== 'SHO'){
                flagCiudad = 1
            }

            let flagEstrato = -1
            if (data.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === (estrato ? estrato : estratoFil))){
                flagEstrato = 1
            }  
            
            if(familia !== 'SHO'){
                flagEstrato = 1
            }


            //console.log("rangeMbbbb",rangeMb)
            /*let flagMb = -1
            if(familia === 'SHO' && (!check || !check.find(c => c === 13))){//idFiltro Internet
                flagMb = 1
            } else {
                let valor = 0;
                data.caracteristicas?.forEach(c => {
                    if(c.fc_TITULO.toLowerCase() === 'datos incluidos' || c.fc_TITULO.toLowerCase() === 'navegación en internet'){
                        
                        let valorSplit = c.fc_VALOR.split(' ')
                        if(valorSplit && valorSplit[0].toLowerCase().includes('gb')){
                            let valorGB = valorSplit[0].toLowerCase().split('gb')
                            valor = !isNaN(valorGB[0]) ? Number(valorGB[0]) : 0 
                        }
                    }
                });
                
            }*/

            let flag = false
            if(!input && check.length === 0){
                flag = true
            } else{
                if(input && flagInput > -1 && check.length === 0){
                   flag = true
                } else {
                    if(flagCheck > -1){
                      flag = true
                    } else {
                      flag = false
                    }
                }
            }
            // console.log("banderas checkHead.length" + data.fi_PLAN, "flag=" + flag, "flagMb="+flagMb)
            if(flag && checkHead.length){
                // console.log("banderas checkHead.length" + data.fi_PLAN, "flag=" + flag, "flagMb="+flagMb)
                flag = false
                data.lstFiltrosxPlan.forEach(option => {
                    let isSameId = checkHead.length ? checkHead.find(a => (a.id === option.fi_OPCION_FILTRO || a.id.toString() === option.fc_VALOR)) : false
                    if (isSameId) {
                        flag = true
                    }
                })
                if(check){
                    data.lstFiltrosxPlan.forEach(option => {
                        let isSameId = check.length ? check.find(a => (a.id === option.fi_OPCION_FILTRO || a.id.toString() === option.fc_VALOR)) : false
                        if (isSameId) {
                            flag = true
                            let idFilter = parseInt(option.fc_VALOR)
                            let fiterToCheck = dataFilterTypes.find(f => (f.id === idFilter))
                            console.log("banderas lstFiltrosxPlan " + data.fi_PLAN, "flag="+flag, data.fc_NOMBRE+":", option, check, fiterToCheck)
                            if(fiterToCheck?.Descripcion.toLowerCase() === "netflix"){
                                if(data.fc_NOMBRE.toLowerCase().indexOf("netflix") < 0){
                                    flag = false
                                }
                            }
                        }
                    })
                }
            }

            
            
            console.log("banderas " + data.fi_PLAN, "flag="+flag, "flagCiudad=" + flagCiudad, "flagEStrato=" +  flagEstrato, "flagCheck=" +  flagCheck, "flagInput=" +  flagInput, "flagMb="+flagMb)
            if(flagCiudad === -1 || flagEstrato  === -1 || flagMb === -1){
                flag = false
            }
            // console.log("banderas " + data.fi_PLAN, "flag=" + flag, "flagMb="+flagMb)
            return flag
        })

        newDataFilter.sort((a,b) => getCalculateEstrato(a).fi_PRECIO_PLAN - getCalculateEstrato(b).fi_PRECIO_PLAN)

        setCounterFilters(ContaFilter + check.filter(c => !c.hijo).length)
        let pageCountVal = newDataFilter.length ? (Math.ceil(newDataFilter.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(newDataFilter)
        setOffset(0)
        handlePageClick({selected:0})
    }

    /*function getFilterPlansMulti(price = null, check = null, comuna = null, option = null, input = null, ciudadB = null, estratoB = null, mb = null ) {
        
        //console.log("function getFilterPlansMultiiii*********** Init::::", dataCPlanesBk)
        // if (inputSearch.length) {
        let data = dataCPlanesBk.length ? dataCPlanesBk : [];
        let ContaFilter = []

        let newDataFilter = data.filter((data, index) => {
            let flagInput = -1, flagCheck = -1;
            //flagComuna = -1, 
            
            if (input && input.length) {
                //console.log("input if getFilterPlansMulti***********", "input: " + input)
                ContaFilter[0] = true
                for (let [key, value] of Object.entries(data)) {

                    if (key === "caracteristicas" && value.length) {
                        for (let [keyC, valueC] of Object.entries(value)) {
                            // let valueCS = String(value)

                            if (valueC.fc_TITULO.toLowerCase().search(inputSearch.toLowerCase()) > -1 || valueC.fc_VALOR.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                                console.log("------------------caracteristicas index:" + index, keyC, valueC.fc_TITULO.toLowerCase(), valueC.fc_VALOR.toLowerCase(), inputSearch.toLowerCase());
                                flagInput = index
                            }
                        }
                    } else {
                        let valueS = String(value)
                        // console.log("------------------ index:"+index, valueS.toLowerCase(), inputSearch.toLowerCase());
                        if (valueS.toLowerCase().search(inputSearch.toLowerCase()) > -1) {
                            //console.log("------------------ index:" + index, key, valueS.toLowerCase());
                            flagInput = index
                        }
                    }
                }
            }
            //console.log("valor input", input, flagInput)
            /*if (comuna) {
                let dcomuna = data.fc_TIPO_DISPONIBILIDAD === comuna;
                ContaFilter[1] = true
                if (dcomuna) {
                    flagComuna = 1
                }
                console.log("comuna if getFilterPlansMulti***********", "comuna: " + comuna, flagComuna)
            }
            let arraykeyCheck = []
            if (check) {
                //console.log("ingreso al check", dataFilterTypes2)
                // let dcheck = data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === parseInt(check)))
                // ContaFilter[4] = true
                // if (dcheck !== undefined) {
                //     flagCheck = dcheck.fi_OPCION_FILTRO
                // }
                // let getByChecked = dataFilterTypes.map((filt, index) => {
                //     if (filt.checked) {
                //         console.log("check if getFilterPlansMulti*********** check:", filt)
                //         return data.lstFiltrosxPlan.find(groupFil => (groupFil.fi_OPCION_FILTRO === filt.id))
                //     } else {
                //         return null;
                //     }
                // })

                
                let keysConta = 3
                dataFilterTypes2.forEach((filt) => {
                    filt.value?.forEach((subfilt, subindex) => {
                        if (subfilt.checked) {
                            keysConta ++
                            arraykeyCheck.push(subfilt.id)
                            ContaFilter[keysConta] = true
                        }
                        subfilt.lstHijos?.forEach((subfilt2, subindex2) =>{
                            if (subfilt2.checked) {
                                keysConta ++
                                arraykeyCheck.push(subfilt2.fi_OPCION_FILTRO)
                                ContaFilter[keysConta] = true
                            }
                        })
                    })
                })
                //console.log("datafil",data)
                let isExist = false
                data.lstFiltrosxPlan.map(option => {
                    let isSameId = arraykeyCheck.find(a => a === option.fi_OPCION_FILTRO)
                    if (isSameId) isExist = true
                    return isExist
                })
                if (isExist) {
                    flagCheck = 1
                }

                //console.log("check if getFilterPlansMulti*********** CheckedsBox: isExist", isExist, result)
            }

            if (flagInput > -1 
                //|| flagComuna > -1 
                || flagCheck > -1 || (flagInput === -1 && ContaFilter.length === 0)) {
                //console.log("FLAGS-------------", flagInput, flagComuna, flagCheck, data)
                return data
            } else {
                //console.log("FLAGS ELSE-------------", flagInput, flagComuna, flagCheck)
                return null
            }
        });
        let dataNew = newDataFilter
        //console.log("dataNew", newDataFilter)
        //newDataFilter.length ? newDataFilter : data
        //console.log("FLAGS newDataFilter-------------", dataNew)
        let newDataFilterPrices = dataNew.filter((data, index) => {
            //let flagPrices = -1
            //let flagMb = -1
            let flagCiudad = -1 
            let flagEstrato = -1
            /*if (price) {
                let dprice = ((data.fi_PRECIO_PLAN >= price.min) === true && (data.fi_PRECIO_PLAN <= price.max) === true);
                // ContaFilter[3] = true
                if (dprice) {
                    flagPrices = 1
                }
                console.log("function getFilterPlansMultiPrice*********** price: ", price, dprice)
            }

            if(mb){

                let dmb = 0
                data.caracteristicas?.forEach(c => {
                    if(c.fc_TITULO.toLowerCase() === 'datos incluidos' || c.fc_TITULO.toLowerCase() === 'navegación en internet'){
                        let valor = 0;
                        let valorSplit = c.fc_VALOR.split(' ')
                        if(valorSplit && valorSplit[0].toLowerCase().includes('gb')){
                            let valorGB = valorSplit[0].toLowerCase().split('gb')
                            valor = valorGB[0]
                        }
                        
                        dmb = !isNaN(valor) ? Number(valor) : 0 ;
                    }
                });
                /*if (dmb) {
                    flagMb = 1
                }
                console.log("function getFilterPlansMulti*********** mb: ", mb, dmb)

            }

            if (data.fi_TODO_CIUDAD === 1){
                //console.log("ciudad", ciudadB, ciudadFil)
                if(!data.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === (ciudadB ? ciudadB : ciudadFil))){
                    flagCiudad = 1
                }
            } else {
                //console.log("ciudad", ciudadB, ciudadFil, data.lstCiudadesxPlan)
                if (data.lstCiudadesxPlan?.find(c => c.fi_ciudad.toString() === (ciudadB ? ciudadB : ciudadFil))){
                    flagCiudad = 1
                }
            }

            if (data.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === (estratoB ? estratoB : estratoFil))){
                flagEstrato = 1
            }

            //console.log("ciudad estrato", flagCiudad, flagEstrato)

            let flagCE = familia === 'SHO' ? flagEstrato > -1 && flagCiudad > -1 : true

            if (flagCE ) {
                return data
            } else {
                return null
            }
        })
        let counter = 0
        ContaFilter.map((item, index) => (
            counter++
        ))

        setCounterFilters(counter)
        
        let list = newDataFilterPrices

        let pageCountVal = newDataFilterPrices.length ? (Math.ceil(newDataFilterPrices.length / perPage)) : 1;
        setPageCount(pageCountVal)
        setdataCPlanes(list)
        // getMinMaxPrice()
        setOffset(0)
        //console.log("to search---------- getFilterPlans:", pageCount, pageCountVal, perPage, newDataFilterPrices, newDataFilterPrices.length)
        // }
    }*/

    function onHandleClickSearch() {
        
        getFilterPlansMulti2(inputSearch, ciudadFil, estratoFil, rangeMbState)
    }

    function routeChange(e) {
        //console.log("routeChange__________***********", inputSearch, dataCPlanesBk,)
        let dataToItems = dataCPlanesBk.filter(f => keysPlanCompare.includes(f.fi_PLAN));
        let arrayItemes = { items: dataToItems }
        console.log("dataToItems::::::::::::::::::::", dataToItems, arrayItemes, keysPlanCompare.length);
        setRegresaPlanes(false)
        setDataToItems(arrayItemes)
        // history.push({ pathname: path, state: { data: { items: dataToItems }, plansToCompare: keysPlanCompare } });
    }

    function handlePageClick(d) {
        console.log("handlePageClick::::::::::::::::::::::::", d)
        setOffset(d.selected)
    }

    useEffect(() => {
        getDataGenAccordion();
        getCaractPostPago();
        getFilterTypesHead();
        getCPlanes();
        getRegiones();
        getFilterTypes();
        getFilterOptions();
        getCiudades();
        getCiudadesByFamilia();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        let preFilter = localStorage.getItem('preFilter') ? localStorage.getItem('preFilter').split(",") : '';
        //console.log("preFilter::::::::::::::::::::::::", preFilter)
        if (preFilter.length) {
            //let FilterId = parseInt(preFilter[1].split(":")[1])
            let filterOption = preFilter[1].split(":")[0]
            
            //console.log("preFilter length::::::::::::::::::::::::", preFilter, FilterId, filterOption)
            if (filterOption === "FilterId") {
                //console.log("FilterId === 1::::::::::::::::::::::::", preFilter, FilterId, filterOption, newArrayChecks)
                setOptionFilter('')
                if (dataCPlanesBk?.length) {
                    //console.log("dataCPlanesBk?.length............................... type 1", preFilterRemove, filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                    if (preFilterRemove) {
                        //console.log("preFilter............................... type 1", filterOption, dataCPlanesBk, dataCPlanes, newArrayChecks, dataFilterTypes)
                        getFilterPlansMulti2(inputSearch, ciudadFil, estratoFil, rangeMb)
                        localStorage.removeItem('preFilter')
                        setPreFilterRemove(!preFilterRemove)
                        //console.log("preFilter............................... removeItem 1")
                    }
                }
            } else if (filterOption === "filterOption") {
                //console.log("FilterId === 2::::::::::::::::::::::::", preFilter, FilterId, filterOption)
                setOptionFilter(filterOption)

                if (dataCPlanesBk?.length) {
                    if (preFilterRemove) {
                        //console.log("preFilter............................... type 2", filterOption, dataCPlanesBk, dataCPlanes)
                        getFilterPlansMulti2(inputSearch, ciudadFil, estratoFil,rangeMb)
                        localStorage.removeItem('preFilter')
                        setPreFilterRemove(!preFilterRemove)
                    }
                }
            }
        }
        // eslint-disable-next-line
    }, [dataCPlanesBk, pageCount])

    useEffect(() => {
    
        let filterHead = queryParams.get("filterHead") ? parseInt(queryParams.get("filterHead")) : null;
        let filterTypes = queryParams.getAll("filterType").map(type => parseInt(type)); // Obtenemos todos los valores de filterType
        let optionType = queryParams.get("optionType") ? parseInt(queryParams.get("optionType")) : null;
    
        console.log("Filters by params:", filterHead, filterTypes, optionType, dataFilterTypesHead, dataFilterTypes, dataFilterTypes2, dataCPlanesBkHead);
    
    
        if (filterHead !== null && dataCPlanesBkHead.length) {
            let el = { target: { checked: true, name: filterHead } };
            let item = dataFilterTypesHead.filter(filt => filt.id === filterHead);
            if (item.length) {
                console.log("prefilter filterHead:", filterHead);
                getPlanesByCheckBoxHead(el, item[0]);
            }
        }
    
    
        filterTypes.forEach(filterType => {
            if (filterType !== null && dataCPlanesBkHead.length) {
                let el = { target: { checked: true, name: filterType } };
                let itemfilterHead;
                for (let i = 0; i < dataFilterTypes2.length; i++) {
                    let valueFitls = dataFilterTypes2[i].value;
                    itemfilterHead = valueFitls.filter(filt => filt.id === filterType);
                    if (itemfilterHead.length) {
                        break;
                    }
                }
    
                let item = itemfilterHead?.length > 0 ? itemfilterHead : [];
                if (item.length) {
                    console.log("prefilter filterType", filterType, item[0]);
                    getPlanesByCheckBox(el, item[0]);
                }
            }
        });
    
    
        if (optionType !== null && dataCPlanesBkHead.length) {
            let el = { target: { checked: true, name: optionType } };
            let itemfilterHead;
            for (let i = 0; i < dataFilterTypes2.length; i++) {
                let valueFitls = dataFilterTypes2[i].value;
                itemfilterHead = valueFitls.filter(filt => filt.id === filterType);
                if (itemfilterHead.length) {
                    break;
                }
            }
    
            let itemfilterType = itemfilterHead.length ? itemfilterHead[0].lstHijos.filter(filt => filt.fi_OPCION_FILTRO === optionType) : [];
            let item = itemfilterType.length ? itemfilterType : [];
            if (item.length) {
                console.log("prefilter optionType", optionType, item[0]);
                getPlanesByCheckBox(el, item[0]);
            }
        }
    }, [dataCPlanesBkHead]);

    function calculateInitElementShow() {
        const result = offset * perPage
        return result
    }

    function calculateFnElementShow() {
        return calculateInitElementShow() + perPage
    }

    function getCalculatePageCount() {

        let pageCountVal = dataCPlanes?.length ? (Math.ceil(dataCPlanes.length / perPage)) : 1;
        return pageCountVal
    }

    function getCalculateEstrato(item){
        const familiaLoc = localStorage.getItem("id_familia")
        const  ciudadId = localStorage.getItem("ciudad")
        const estratoId = localStorage.getItem("estrato")
        if(familiaLoc !== 'SHO'){
            return item
        }
        if(ciudadId !== '-1' && estratoId !== '-1'){
            let estratoItem = item.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === estratoId.toString())
            return estratoItem ? estratoItem : item
        } else {
            return item
        }
    }

    function getTTI(idFiltro){
        let existe = false
        let lstServicios = dataFilterTypes2.find(d => d.idFil === filtros.servicios)?.value
        if(lstServicios){
            lstServicios.forEach(s => {
                if(s.fi_FILTRO === filtros.servicios && s.id === idFiltro && s.checked){
                    existe = true
                }
            })
        }
        return existe
    }

    function getPrecioIndividual(id){        
        let precio = 0
        let item = dataCPlanesBk.find(p => p.fi_PLAN === id)
        if(item){
            let itemEstrato = getCalculateEstrato(item)
            precio = itemEstrato.fi_PRECIO_PLAN
        }

        return precio
    }

    function getDescripcionIndividual(id){        
        let descripcion = ''
        let item = dataCPlanesBk.find(p => p.fi_PLAN === id)
        if(item){
            descripcion = item.fc_DESCRIPCION_PAQUETE
        }

        return descripcion
    }

    const optionsCiudades = dataCiudades.length ? dataCiudades.map((item, index) => (
        <option key={uuid()} name={item.fc_descripcion} value={item.fi_ciudad}>{item.fc_descripcion}</option>
    )) : null

    const optionsCiudadesLogic = dataCiudadesLogic?.length ? dataCiudadesLogic.map((item, index) => (
        <option key={uuid()} name={item.fc_descripcion} value={item.fi_ciudad}>{item.fc_descripcion}</option>
    )) : null

    
    const idsOcultos = [456,454,455,451,452,449];
    const PlayPLanData = dataCPlanes.length ? dataCPlanes.filter(item => !idsOcultos.includes(item.fi_PLAN)).slice(calculateInitElementShow(), calculateFnElementShow()).map((item, index) => {
        
        let itemEstrato = getCalculateEstrato(item)
        const telefonia = getTTI(filtros.telefoniaFija)
        const television = getTTI(filtros.television)
        const internet = getTTI(filtros.internet)

        let precioInternet = item.fi_ID_INTERNET && familia === 'SHO' ? getPrecioIndividual(item.fi_ID_INTERNET) : 0
        let precioTelefonia = item.fi_ID_TELEFONIA && familia === 'SHO' ? getPrecioIndividual(item.fi_ID_TELEFONIA) : 0
        let precioTelevision = item.fi_ID_TELEVISION && familia === 'SHO' ? getPrecioIndividual(item.fi_ID_TELEVISION) : 0

        let precioCombo = precioInternet + precioTelefonia + precioTelevision

        let descripcionInternet = item.fi_ID_INTERNET && familia === 'SHO' ? getDescripcionIndividual(item.fi_ID_INTERNET) : ''
        let descripcionTelefonia = item.fi_ID_TELEFONIA && familia === 'SHO' ? getDescripcionIndividual(item.fi_ID_TELEFONIA) : ''
        let descripcionTelevision = item.fi_ID_TELEVISION && familia === 'SHO' ? getDescripcionIndividual(item.fi_ID_TELEVISION) : ''
        console.log("postPagoCarac",postPagoCarac)
        return (
            <div key={uuid()} className={`c23Item plan ${item?.fc_CRC ? item?.fc_CRC : '' }`} data-idplan={item.fi_PLAN} >
                <General2PlanCardMol
                    key={uuid()}
                    title={item.fc_TEXTO_CAJA}
                    titlestyle={item?.fc_COLOR_CAJA ? item?.fc_COLOR_CAJA.toLowerCase() : null}
                    name={item.fc_NOMBRE}
                    changeCompare={handleChangeCompare}
                    fi_PLAN={item.fi_PLAN}
                    fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                    fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                    fi_ID_INTERNET={item.fi_ID_INTERNET}
                    fi_CATEGORIA={item.fi_CATEGORIA}
                    fi_SERVICIO={item.fi_CATEGORIA === 3 ? 2 : null}
                    fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                    fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                    fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                    fc_NOMBRE={item.fc_NOMBRE}
                    fc_DESCRIPCION={item.fc_DESCRIPCION}
                    fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                    fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                    fi_PRECIO_PLAN={<NumberFormat id={`PRECIO_${item.fi_PLAN}`} thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={ciudadFil !== '-1' && estratoFil !== '-1' ? itemEstrato.fi_PRECIO_PLAN : item.fi_PRECIO_PLAN} 
                                        renderText={(value, props) => <span {...props}>{value}</span>} 
                                    />}
                    fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                    fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                    fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                    fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                    fc_ETIQUETA_PRECIO_TACHADO={ciudadFil !== '-1' && estratoFil !== '-1' ? itemEstrato.fc_ETIQUETA_PRECIO_TACHADO : item.fc_ETIQUETA_PRECIO_TACHADO}
                    fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={ciudadFil !== '-1' && estratoFil !== '-1' ? itemEstrato.fi_PRECIO_TACHADO : item.fi_PRECIO_TACHADO } />}
                    Discount={
                        ciudadFil !== '-1' && estratoFil !== '-1' ?
                            itemEstrato?.fi_PRECIO_TACHADO > 0 
                            && parseInt(itemEstrato.fi_PRECIO_TACHADO) !== parseInt(itemEstrato.fi_PRECIO_PLAN) 
                            ? <NumberFormat displayType={'text'} value={(100 - (itemEstrato.fi_PRECIO_PLAN * 100) / itemEstrato.fi_PRECIO_TACHADO).toFixed(0)} /> 
                            : null
                        :
                            item?.fi_PRECIO_TACHADO > 0 
                            && parseInt(item.fi_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) 
                            ? <NumberFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fi_PRECIO_TACHADO).toFixed(0)} /> 
                            : null
                        }
                    fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                    fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                    fc_URL_DETALLE={item.fc_URL_DETALLE}
                    fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                    fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                    fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                    fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                    fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                    fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                    fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                    fi_ORDEN={item.fi_ORDEN}
                    fi_ACTIVO={item.fi_ACTIVO}
                    fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                    fi_BAN_ENPN={item.fi_BAN_ENPN}
                    fi_BAN_ENPS={item.fi_BAN_ENPS}
                    fi_BAN_ESPN={item.fi_BAN_ESPN}
                    fi_BAN_ESPS={item.fi_BAN_ESPS}
                    fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                    fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                    fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                    Caracteristicas={item.caracteristicas}
                    Acordeon={item.acordeon}
                    dataGenAccordion={dataGenAccordion}
                    lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                    keysPlanCompare={keysPlanCompare}
                    filterPostPago={filterPostPago}
                    postPagoCarac={postPagoCarac}
                    Estrato={item?.lstEstratosxPlan?.length > 0 ? item.lstEstratosxPlan.map(l => { return l.fi_ESTRATO }).join() : ''}
                    Dane={item.fc_DANE}
                    fc_NOTA_DETALLE_PROMOCION={item?.fc_NOTA_DETALLE_PROMOCION}
                    fc_DURACION={item?.fc_DURACION}
                    fc_CRC={item?.fc_CRC}
                    fc_PLAN_ICONO={item?.fc_PLAN_ICONO}
                    fi_INCLUIR_SECCION={item?.fi_INCLUIR_SECCION}
                    fc_ETIQUETA_ROJA={item?.fc_ETIQUETA_ROJA}
                    fc_TITULO_SECCION={item?.fc_TITULO_SECCION}
                    fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
                    fc_URL_BOTON={item?.fc_URL_BOTON}
                    fc_TARGET_BOTON={item?.fc_TARGET_BOTON}
                    fc_TEXTO_BOTON={item?.fc_TEXTO_BOTON}
                    fc_TITULO_PROMO={item?.fc_TITULO_PROMO}
                    fc_DESCRIPCION_OFERTA={item?.fc_DESCRIPCION_OFERTA}
                    caracteristicasPromocion={item?.lstCaracteristicaPromocion}
                    optionsCiudadesLogic={optionsCiudadesLogic}
                    fc_TECNOLOGIA_TELEVISION={item.fc_TECNOLOGIA_TELEVISION}
                    fc_TECNOLOGIA_INTERNET={item.fc_TECNOLOGIA_INTERNET}
                    telefonia={telefonia}
                    television={television}
                    internet={internet}
                    ciudad={ciudadFil}
                    fi_PRECIO_INTERNET={<NumberFormat prefix='$' thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={precioInternet} />}
                    fi_PRECIO_TELEVISION={<NumberFormat prefix='$' thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={precioTelevision} />}
                    fi_PRECIO_TELEFONIA={<NumberFormat prefix='$' thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={precioTelefonia} />}
                    precioCombo={<NumberFormat prefix='$' thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={precioCombo} />}
                    fc_DESCRIPCION_INTERNET={descripcionInternet}
                    fc_DESCRIPCION_TELEVISION={descripcionTelevision}
                    fc_DESCRIPCION_TELEFONIA={descripcionTelefonia}
                />
                {/* <PlayPlanCardMol
                    key={uuid()}
                    title={item.fc_TEXTO_CAJA}
                    titlestyle={item?.fc_COLOR_CAJA ? item?.fc_COLOR_CAJA.toLowerCase() : null}
                    name={item.fc_NOMBRE}
                    changeCompare={handleChangeCompare}
                    fi_PLAN={item.fi_PLAN}
                    fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                    fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                    fi_ID_INTERNET={item.fi_ID_INTERNET}
                    fi_CATEGORIA={item.fi_CATEGORIA}
                    fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                    fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                    fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                    fc_NOMBRE={item.fc_NOMBRE}
                    fc_DESCRIPCION={item.fc_DESCRIPCION}
                    fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                    fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                    fi_PRECIO_PLAN={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={item.fi_PRECIO_PLAN} />}
                    fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                    fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                    fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                    fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                    fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                    fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={item.fc_PRECIO_TACHADO} />}
                    fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                    fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                    fc_URL_DETALLE={item.fc_URL_DETALLE}
                    fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                    fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                    fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                    fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                    fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                    fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                    fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                    fi_ORDEN={item.fi_ORDEN}
                    fi_ACTIVO={item.fi_ACTIVO}
                    fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                    fi_BAN_ENPN={item.fi_BAN_ENPN}
                    fi_BAN_ENPS={item.fi_BAN_ENPS}
                    fi_BAN_ESPN={item.fi_BAN_ESPN}
                    fi_BAN_ESPS={item.fi_BAN_ESPS}
                    fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                    fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                    fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                    Caracteristicas={item.caracteristicas}
                    Acordeon={item.acordeon}
                    lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                    keysPlanCompare={keysPlanCompare}
                    filterPostPago={filterPostPago}
                    postPagoCarac={postPagoCarac}
                    Estrato={item?.lstEstratosxPlan?.length > 0 ? item.lstEstratosxPlan.map(l => {return l.fi_ESTRATO}).join() : ''}
                    Dane={item.fc_DANE}
                    fc_NOTA_DETALLE_PROMOCION={item?.fc_NOTA_DETALLE_PROMOCION}
                    fc_DURACION={item?.fc_DURACION}
                /> */}
            </div>
            )
    }) : null

    // let perPage = 6;
    const onSubmitFilter = data => {
        //console.log('Submit filters:', data);
    }

    let rangePrice = {
        min: rangePriceState.min,
        max: rangePriceState.max,
    }

    let rangeMb = {
        min: rangeMbState.min,
        max: rangeMbState.max,
    }

    const optionsRegiones = dataRegiones.length ? dataRegiones.map((item, index) => (
        <option key={uuid()} value={item.value}>{item.label}</option>
    )) : null

    const optionsFilterOptions = dataFilterOptions.length ? dataFilterOptions.map((item, index) => (
        <option key={uuid()} value={item.value}>{item.label}</option>
    )) : null

    //console.log('dataFilterTypes', dataFilterTypes, pageCount);
    //console.log('caracteristicaPostPago', caracteristicaPostPago);

    const modalLocationRef = useRef()
    const openModalLocation = () => modalLocationRef.current.open()
    const closeModalLocation = () => modalLocationRef.current.close()

    const modalTooltipRef = useRef()
    const openModalTooltip = () => modalTooltipRef.current.open()

    const onClickChangeLocation = () => {
        openModalLocation()
    }

    const onClickAgreeLocation = () => {
        //console.log('Confirmar')
        localStorage.setItem("estrato", estratoFil)
        localStorage.setItem("ciudad", ciudadFil)
        getFilterPlansMulti2(inputSearch, null, null, rangeMbState)
        closeModalLocation()
    }

    const onClickChangeLocationClose = () => {    
        closeModalLocation()
    }

    const filterMulti = (ciudad, estrato) => {
        //console.log("mandando estrao ciudad", ciudad, estrato)
        getFilterPlansMulti2(inputSearch, ciudad, estrato, rangeMbState)
    }
    console.log("dataCPlanes", dataCPlanes)

    const [isLoading, setIsLoading] = useState(true); 

    useEffect(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false); 
        }, 1500); 
    }, []);
    return (

        dataToItems?.items && !regresaPlanes
            ?
            <C25PeopleOrg
                key={uuid()}
                dataCompare={dataToItems}
                resetHandleClick={resetHandleClick}
                removeItemHandleClick={removeItemHandleClick}
                postPagoCarac={postPagoCarac}
                dataGenAccordion={dataGenAccordion}
                optionsCiudadesLogic={optionsCiudadesLogic}
                setRegresaPlanes={setRegresaPlanes}
            />
            :
            <>
            <section className='c23Wrap'>
                <div className="container">
                    <div className="c23">

                        {/* <div className="c23Breadcrumb">
                        <BreadcrumbMol 
                            backToText='Volver a Servicios Hogar'
                        />
                    </div> */}
                        <div className="c23Fil">
                            <ServiceFilter
                                onSubmit={onSubmitFilter}
                                rangePrice={rangePrice}
                                rangeMb={rangeMb}
                                rangeMbMax={rangeMb.max}
                                rangeMbMin={rangeMb.min}
                                showFilter={showFilter}
                                setShowFilter={setShowFilter}
                                // dataRegiones={dataRegiones}
                                optionsRegiones={optionsRegiones}
                                optionsCiudades={optionsCiudades}
                                dataFilterTypes={dataFilterTypes2}
                                dataFilterTypesHead={dataFilterTypesHead}
                                handleChangeFilterPrice={handleChangeFilterPrice}
                                handleChangeFilterMb={handleChangeFilterMb}
                                //getPlanesByComuna={getPlanesByComuna}
                                getPlanesByCheckBox={getPlanesByCheckBox}
                                getPlanesByCheckBoxHead={getPlanesByCheckBoxHead}
                                // keysTypeCompare={keysTypeCompare}
                                counterFilters={counterFilters + counterFiltersHead}
                                clearFilters={clearFilters}
                                familia={familia}
                                setCiudad={setCiudadFil}
                                setCiudadText={setCiudadText}
                                ciudad={ciudadFil}
                                setEstrato={setEstratoFil}
                                setEstratoText={setEstratoText}
                                estrato={estratoFil}
                                filterMulti={filterMulti}
                            />
                        </div>
                        <div className="c23Cont">
                            <Title
                                tag={TitleTag.H2}
                                /* style={TitleStyle.H2} */
                                className='c23HeaderTit'
                            >
                                {
                                    localStorage.getItem('titulo_seccion') ? localStorage.getItem('titulo_seccion') : null
                                }
                            </Title>
                            <div className="c23Bar">
                                <div className="c23BarDrop">
                                    <span className="select">
                                        <select defaultValue='' value={optionFilter} onChange={(selected) => { onChangeFilterOptions(selected); }}>
                                            <option value='' disabled>Ordenar por:</option>
                                            {optionsFilterOptions}
                                        </select>
                                    </span>
                                </div>
                                <div className="c23BarSearch">
                                    <SearchField
                                        onChange={e => onChangeInputSearch(e)}
                                        value={inputSearch}
                                    />

                                </div>
                                <div className="c23BarAct">
                                    <Button
                                        onClick={e => onHandleClickSearch(e)}
                                    >
                                        Buscar
                                    </Button>
                                </div>
                            </div>

                            <div className="c23Header">
                                <div className='c23HeaderFilter' onClick={() => { setShowFilter(!showFilter) }}>

                                    <p>Filtros <i className='ico-sliders'></i></p>

                                </div>
                                <div className="c23HeaderComp">
                                    <div className="c23HeaderCompRad">
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[0]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[0] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[1]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[1] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[2]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[2] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[3]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[3] ? true : false}
                                        />
                                        <InputSelect
                                            type={InputSelectType.RADIO}
                                            text=''
                                            name='comparee[4]'
                                            className=''
                                            disabled={true}
                                            checked={keysPlanCompare[4] ? true : false}
                                        />
                                    </div>
                                    <div className="c23HeaderCompBtn">

                                        <Button
                                            category={ButtonCategory.TRANS_GRIS}
                                            onClick={keysPlanCompare.length >= 2 ? e => routeChange(e) : e => openModalTooltip(e)}
                                        >
                                            Comparar servicios
                                        </Button>
                                    </div>

                                </div>
                            </div>
                                {
                                    familia === 'SHO' && 
                                    <p className='c23Notice'>
                                        <strong>Aviso Importante:</strong> Los precios aplican para {ciudadFil !== '-1' ? ciudadText : ''}, {estratoFil !== '-1' ? estratoText : ''} <a href="#!" className='link linked' onClick={()=>{onClickChangeLocation()}}> Cambiar </a>
                                    </p>
                                }
                            <div className="c23Items">
                            {
                                isLoading ?  null 
                                : dataCPlanes.length === 0 ? 
                                  (<h3 style={{ margin: '25px', textAlign: 'center' }}>No se encontraron resultados</h3>) 
                                  :PlayPLanData
                            }

                            </div>
                            <div className="c23Pag">
                                
                                {
                                    dataCPlanes.length
                                        ?
                                        <PaginationMol
                                            pageCount={getCalculatePageCount()}
                                            onPageChange={handlePageClick}
                                            initialPage={0}
                                            forcePage={offset}
                                        // previousLabel={'Ant.'}
                                        // nextLabel={'Sig.'}
                                        />
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Modal 
                ref={modalLocationRef}
                size={ModalSize.SMALL_2}
            >
                <MLocationPartModal 
                    onAgree={onClickAgreeLocation}
                    onClose={onClickChangeLocationClose}
                    setCiudad={setCiudadFil}
                    setCiudadText={setCiudadText}
                    ciudad={ciudadFil}
                    listCiudades={dataCiudades}
                    setEstrato={setEstratoFil}
                    setEstratoText={setEstratoText}
                    estrato={estratoFil}
                />
            </Modal>
            <Modal 
               ref={modalTooltipRef}
               size={ModalSize.SMALL}
            >
            <MTooltipModal 
                    mensaje={"Debes selecionar al menos 2 servicios"}
                />
            </Modal>

            </>
    )
}

export default C23PersonasOrg